import React from "react";

const UsersSVG = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6663 14.5V13.1667C10.6663 12.4594 10.3854 11.7811 9.88529 11.281C9.3852 10.781 8.70692 10.5 7.99967 10.5H3.99967C3.29243 10.5 2.61415 10.781 2.11406 11.281C1.61396 11.7811 1.33301 12.4594 1.33301 13.1667V14.5"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.667 2.58533C11.2388 2.73357 11.7453 3.0675 12.1068 3.5347C12.4683 4.0019 12.6645 4.57592 12.6645 5.16666C12.6645 5.7574 12.4683 6.33142 12.1068 6.79862C11.7453 7.26582 11.2388 7.59975 10.667 7.74799"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.667 14.5V13.1667C14.6666 12.5758 14.4699 12.0019 14.1079 11.5349C13.7459 11.0679 13.2391 10.7344 12.667 10.5867"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.99967 7.83333C7.47243 7.83333 8.66634 6.63943 8.66634 5.16667C8.66634 3.69391 7.47243 2.5 5.99967 2.5C4.52692 2.5 3.33301 3.69391 3.33301 5.16667C3.33301 6.63943 4.52692 7.83333 5.99967 7.83333Z"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UsersSVG;
